import { createSwrListStore } from './swr/createSwrListStore';
import { getOrgAssets } from '../lib/api';
import { normalizeAssetImageFields } from '../utils/assetImageResolver';

/**
 * Organization-level asset store.
 * Assets here are scoped to the user's org (or user if no org) and persist across projects.
 * Cache survives page reloads via localStorage; keyed by user id to avoid cross-user leaks.
 */
const swr = createSwrListStore({
  name: 'OrgAssetsStore',
  storageKey: 'bookthing-org-assets',
  itemsField: 'orgAssets',
  setters: {
    set: 'setOrgAssets',
    add: 'addOrgAsset',
    update: 'updateOrgAsset',
    remove: 'deleteOrgAsset',
    reset: 'resetOrgAssets',
  },
  fetcher: async () => {
    const resp = await getOrgAssets();
    return (resp.assets || []).map((asset) => normalizeAssetImageFields(asset));
  },
});

export const useOrgAssetsStore = swr.useStore;
export const useOrgAssetsData = swr.useData;
export const fetchOrgAssetsIfStale = swr.fetchIfStale;
